export const MEMBERSHIP_QUERY = `
  query SHREligible {
    membership(id: "", type: JWT_TOKEN) {
      accountToken
      demographics {
        isTopCard
      }
      travelBenefits {
        name
      }
    }
  }
`;
